<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-text-field
                ref="input"
                v-model="inputValue"
                v-mask="maskValue"
                v-test-id="testId"
                class="edit__string__input"
                :name="name || uuid"
                type="text"
                outlined
                dense
                :rules="validators"
                :label="hideLabel ? null : label"
                :hint="hint"
                :description="description"
                :placeholder="hidePlaceholder ? null : placeholder"
                background-color="background"
                color="primaryText"
                :hide-details="hideDetails || (!form && _.isEmpty(validators))"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error="error"
                :error-messages="errorMessages"
                @focus="$emit('focus', inputValue)"
                @blur="$emit('blur', inputValue)"
                @keyup="$emit('keyup', inputValue)"
                @keydown="$emit('keydown', inputValue)"
                @click="$emit('click', inputValue)"
            >
                <template #prepend>
                    <slot name="prepend" />
                </template>
                <template #prepend-inner>
                    <slot name="prepend-inner" />
                </template>
                <template #append>
                    <slot name="append" />
                    <app-tooltip
                        v-if="multiple && (!inputValue || !inputValue.includes(','))"
                        :value="$t('enter_a_comma_separated_list')"
                    >
                        <v-icon dense small color="info" style="margin-bottom: 0.1rem">{{
                            getIcon('info', 'fad')
                        }}</v-icon>
                    </app-tooltip>
                    <app-tooltip v-if="info || findSlot('info')" :value="info">
                        <v-icon dense small color="info" style="margin-bottom: 0.1rem">{{
                            getIcon('info', 'fad')
                        }}</v-icon>
                        <template v-if="findSlot('info')" #display>
                            <slot name="info" />
                        </template>
                    </app-tooltip>
                    <app-button
                        v-if="clearable && !readonly && !disabled && !required && inputValue"
                        :icon="getIcon('clear', 'far')"
                        class="ml-2"
                        small
                        icon-size="1.4em"
                        @click="inputValue = null"
                    />
                </template>
                <template #append-outer>
                    <slot name="append-outer" />
                </template>
            </v-text-field>
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditString',
    extends: Edit,
    props: {
        value: {
            type: [String, Number, Array],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputValue: {
            get() {
                if (this.multiple && Array.isArray(this.value)) {
                    return this.value.join(', ');
                }

                return this.value;
            },
            set(value) {
                if (this.multiple && value) {
                    this.$emit(
                        'input',
                        value
                            .split(',')
                            .map(v => v.trim())
                            .filter(v => v)
                    );
                } else {
                    this.$emit('input', value);
                }
            }
        }
    }
};
</script>

<style lang="scss">
.edit__string {
    min-width: 7rem;
}
</style>
